<script setup>
import { defaultEmployeeImage, photo } from "@/views/production/mixin/common"
import moment from 'moment';
import { onMounted } from "vue";
import IconUser from '@/components/icons/IconUser.vue'
import IconCalendar from '@/components/icons/IconCalendar.vue'

// eslint-disable-next-line no-unused-vars
const props = defineProps({
  happyVerde: {
    type: Array,
    required: true
  }
})

onMounted(() => {

})


const formatDate = (date) => {
  if (!date) return '';
  return moment(date, 'YYYY-MM-DD').format('dddd, DD') + ' de ' + moment(date, 'YYYY-MM-DD').format('MMMM');
}

</script>

<template>

  <el-row>
    <el-col :span="24">
      <div class="table table-users-medium pt-0 px-4 w-100">
        <table>
          <thead>
            <tr>
              <th>
                <div class="d-flex justify-content-start">
                  <img src="@/assets/icons/user.svg" alt="" width="20" />
                  <span class="ml-1">NOMBRES Y APELLIDOS</span>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start">
                  <img src="@/assets/icons/calendar-icon.svg" alt="" width="20" />
                  <span class="mt-1 ml-1">FECHA</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="happy in happyVerde" :key="happy.id + happy.name">
              <td>
                <div class="d-flex align-items-center">
                  <el-avatar :src="photo(happy)" class="avatar-user-birthday">
                    <img :src="defaultEmployeeImage" alt="Default Image">
                  </el-avatar>
                  <span style="margin-left: 7px;">{{ happy.name }}</span>
                </div>
              </td>
              <td>
                {{ formatDate(happy.birthday) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-users-small pt-0 px-4 mt-2 w-100" v-if="happyVerde.length > 0">
        <div v-for="birthday in happyVerde" :key="birthday.id + birthday.birthday">
          <el-row>
            <el-card class="box-card-user-birthday">
              <div class="row d-flex birthday-card-content">
                <div class="el-col-xs-5 avatar-table-user-birthday">
                  <el-avatar :src="photo(birthday)" class="avatar-user-birthday">
                    <img :src="defaultEmployeeImage" alt="Default Image">
                  </el-avatar>
                </div>
                <div class="el-col-xs-19 d-flex row text-table-user-birthday">
                  <div class="el-col-xs-24">
                    <IconUser style="width: 14px; " class="icons-user-info-birthday" />
                    <span>{{ birthday.name }}</span>
                  </div>
                  <div class="el-col-xs-24">
                    <IconCalendar style="width: 14px;" class="icons-user-info-birthday" />
                    <span class="date-user-birthday">{{ formatDate(birthday.birthday) }}</span>
                  </div>
                </div>
              </div>
            </el-card>
          </el-row>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<style scoped lang="scss">
#islands {
  fill: $bg-blue;
  width: 25px;
}

#calendar-icon {
  fill: $bg-blue;
  height: 25px;
  width: 25px;
}

.card-title {
  letter-spacing: -0.05em;

  font-weight: bolder;
  margin-right: 10px;
  letter-spacing: -0.05em;
  font-size: 1.5em;
  color: $font-blue-color;
}

.table-users-medium {
  table {
    thead {
      tr {
        th {
          padding: 0px !important;
          margin: 0px !important;
        }
      }
    }

    tbody {
      td {
        letter-spacing: -0.05em;

        font-weight: bolder;

        letter-spacing: -0.05em;
        font-size: 0.9em;

        .link-name {
          margin: auto;
          margin-left: 10px;
        }
      }
    }
  }
}

.table-users-small {
  display: none;

  .box-card-user-birthday {
    border-radius: 12px;
    padding: 10px 7px;
    margin-top: 10px;

    span {
      font-size: 16px;
      font-weight: 600;
    }

    .date-user-birthday {
      color: #F9156F;
    }
  }

  .avatar-table-user-birthday {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 2px;

    .avatar-user-birthday {
      width: 45px;
      height: 45px;
      min-width: 45px;
    }
  }

  .icons-user-info-birthday {
    margin-right: 2px;
    margin-top: -5px;
  }
}


@media screen and (max-width: 767px) {
  .table-users-small {
    display: block;

    .box-card-user-birthday {
      padding: 5px;
      margin-top: 0;

      .birthday-card-content {
        align-items: center;
        margin-left: 0;
        margin-right: 0;
        min-height: 70px;
      }

      span {
        font-weight: 500;
      }

      .date-user-birthday {
        font-weight: 600;
      }
    }

    .avatar-table-user-birthday {
      margin-right: 0;
      padding-left: 4px;

      .avatar-user-birthday {
        width: 54px;
        height: 54px;
        min-width: 54px;
      }
    }

    .text-table-user-birthday {
      padding-right: 0px !important;
    }
  }

  .table-users-medium {
    display: none;
  }

  .card-title {
    margin-right: -3px;
  }
}
</style>
